<template functional>
	<div :class="[$style.section, data.staticClass]">
		<div v-if="props.title || slots().head" :class="$style.section_head">
			<slot name="head">
				<h3 :class="$style.section_head_title">{{ props.title }}</h3>
				<div :class="$style.section_head_subtitle">{{ props.subtitle }}</div>
			</slot>
			<slot name="head-extra"></slot>
		</div>
		<div :class="$style.section_body">
			<slot />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
	props: {
		title: String,
		subtitle: String
	}
});
</script>
<style lang="scss" module>
.section {
  --header-padding: 24px 24px 12px 24px;
  --body-padding: 8px 24px 24px 24px;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.section_head {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  -webkit-align-items: baseline;
  align-items: baseline;
  font-size: 1.625rem;
  padding: var(--header-padding);
}
.section_head_title {
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.section_head_subtitle {
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-left: 0.75rem;
}
.section_body {
  padding: var(--body-padding);
}
</style>